
/*
 * ! @chakra-ui/vue v0.12.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { R as createStyledAttrsMixin, u as useVariantColorWarning, J as useId } from './index-2557a15f.js';
import './chakra-ui-styled-system.esm-36097b89.js';
import '@emotion/css';
import 'vue';
import './color-mode-observer-d3e4ca7f.js';
import CBox from './CBox.js';
import CVisuallyHidden from './CVisuallyHidden.js';
import CControlBox from './CControlBox.js';
import { u as useCheckboxStyle } from './checkbox.styles-b7a889b2.js';

/**
 * Hey! Welcome to @chakra-ui/vue CRadio
 *
 * Radios are used when only one choice may be
 * selected in a series of options.
 *
 * @see Docs     https://vue.chakra-ui.com/radio
 * @see Source   https://github.com/chakra-ui/chakra-ui-vue/blob/master/packages/chakra-ui-core/src/CRadio/CRadio.js
 */
/**
 * CRadio component
 *
 * The accessible radio component
 *
 * @extends CBox
 * @see Docs https://vue.chakra-ui.com/radio
 */

var CRadio = {
  name: 'CRadio',
  mixins: [createStyledAttrsMixin('CRadio')],
  model: {
    prop: 'isChecked',
    event: 'checked'
  },
  props: {
    id: String,
    name: String,
    value: [String, Number],
    ariaLabel: String,
    ariaLabelledBy: String,
    variantColor: {
      type: String,
      default: 'blue'
    },
    defaultIsChecked: Boolean,
    isChecked: Boolean,
    isFullWidth: Boolean,
    size: {
      type: String,
      default: 'md'
    },
    isDisabled: Boolean,
    isInvalid: Boolean
  },
  computed: {
    radioStyles: function radioStyles() {
      useVariantColorWarning(this.theme, 'Radio', this.variantColor);
      return useCheckboxStyle({
        color: this.variantColor,
        size: this.size,
        colorMode: this.colorMode,
        type: 'radio'
      });
    },
    componentStyles: function componentStyles() {
      return {
        display: 'inline-flex',
        verticalAlign: 'top',
        alignItems: 'center',
        width: this.isFullWidth ? 'full' : undefined,
        cursor: this.isDisabled ? 'not-allowed' : 'pointer'
      };
    },
    _id: function _id() {
      return this.id || "radio-" + useId(4);
    }
  },
  mounted: function mounted() {
    var this$1 = this;
    this.$nextTick(function () {
      this$1.$emit('checked', Boolean(this$1.defaultIsChecked));
    });
  },
  render: function render(h) {
    var this$1 = this;
    var children = this.$slots.default;
    return h('label', {
      class: [this.className],
      attrs: Object.assign({}, {
        for: this.id
      }, this.computedAttrs)
    }, [h(CVisuallyHidden, {
      props: {
        as: 'input'
      },
      domProps: {
        checked: this.isChecked,
        value: this.value
      },
      attrs: {
        type: 'radio',
        'aria-label': this.ariaLabel,
        'aria-labelledby': this.ariaLabelledBy,
        id: this.id,
        name: this.name,
        'aria-invalid': this.isInvalid,
        disabled: this.isDisabled,
        'aria-disabled': this.isDisabled
      },
      nativeOn: {
        change: function change(e) {
          this$1.$emit('change', e);
          this$1.$emit('checked', e.target.checked);
        }
      }
    }), h(CControlBox, {
      attrs: Object.assign({}, this.radioStyles, {
        rounded: 'full',
        type: 'radio'
      })
    }, [h(CBox, {
      props: {
        as: 'span'
      },
      attrs: {
        bg: 'currentColor',
        rounded: 'full',
        w: '50%',
        h: '50%'
      }
    })]), children && h(CBox, {
      attrs: {
        ml: 2,
        fontSize: this.size,
        fontFamily: 'body',
        userSelect: 'none',
        opacity: this.isDisabled ? 0.32 : 1
      }
    }, children)]);
  }
};

export default CRadio;
